import { Check } from "lucide-react";
import { useTheme, type Palette } from "./theme-provider";
import { palettes } from "@/lib/palette-config";

interface PaletteSelectorProps {
  value?: Palette;
  onChange?: (palette: Palette) => void;
}

export function PaletteSelector({ value, onChange }: PaletteSelectorProps = {}) {
  const { palette: contextPalette, setPalette: contextSetPalette } = useTheme();
  const currentPalette = value !== undefined ? value : contextPalette;
  const handleChange = onChange || contextSetPalette;

  return (
    <div className="flex items-center gap-3">
      {palettes.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => handleChange(p.id)}
          className={`
            relative w-8 h-8 rounded-full transition-all duration-200
            ${currentPalette === p.id ? "ring-2 ring-offset-2 ring-offset-background scale-110" : "hover:scale-105"}
          `}
          style={{
            background: `linear-gradient(135deg, ${p.gradientFrom}, ${p.gradientTo})`,
            ...(currentPalette === p.id ? { boxShadow: `0 0 12px ${p.accent}60` } : {}),
          }}
          title={p.name}
          aria-label={`Select ${p.name} theme`}
          aria-pressed={currentPalette === p.id}
        >
          {currentPalette === p.id && (
            <Check className="w-4 h-4 text-white absolute inset-0 m-auto drop-shadow-md" />
          )}
        </button>
      ))}
    </div>
  );
}
